import { useRef, useEffect } from "react";
const useCustomEventsListener = (eventsListener, dependencies = []) => {
  const eventsListenerRef = useRef(eventsListener);
  useEffect(() => {
    eventsListenerRef.current = eventsListener;
  });
  useEffect(() => {
    if (!eventsListenerRef.current) return;
    Object.entries(eventsListenerRef.current).forEach(([event, handler]) => {
      window.addEventListener(event, handler);
    });
    return () => {
      Object.entries(eventsListenerRef.current).forEach(([event, handler]) => {
        window.removeEventListener(event, handler);
      });
    };
  }, dependencies);
};
const useCustomEventsListener$1 = useCustomEventsListener;
export {
  useCustomEventsListener$1 as default
};
